import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUBSCRIPTION_COUNTRY_STAFF_COUNT = createFcmDetails('subscription_country_staff_count', {
	owner: 'Membership Squad',
	context: 'PSF Membership Ask',
	description: 'This FC is used on membership-ask pages to display staff count',
	import: false,
});
